import { API_RESOURCE } from '@/constants/api.constant'
import { axios } from '@/lib/axios'
import CrudService from '@/services/crudService'

class ApplicationService extends CrudService {
  static resource = API_RESOURCE.APPLICATION

  static approveApplication = async ({ id, remark }) => {
    try {
      const response = await axios.put(`/${this.resource}/${id}/approve`, { remark })
      return response.data
    } catch (error) {
      console.error(`Error approve ${this.resource} with id ${id}`, error)
      throw error
    }
  }

  static rejectApplication = async ({ id, remark }) => {
    try {
      const response = await axios.put(`/${this.resource}/${id}/reject`, { remark })
      return response.data
    } catch (error) {
      console.error(`Error approve ${this.resource} with id ${id}`, error)
      throw error
    }
  }

  static fetchApplicationApprovals = async ({ page = 1, pageSize = 20, sortBy = '', orderBy = '', filters = {} }) => {
    try {
      let url = `${this.resource}/approvals?page=${page}&limit=${pageSize}`

      if (sortBy !== '') {
        url += `&sortBy=${sortBy}&orderBy=${orderBy}`
      }

      for (const [filterKey, filterValue] of Object.entries(filters)) {
        url += `&${filterKey}=${encodeURIComponent(filterValue)}`
      }
      const response = await axios.get(url)
      if (!response?.data?.success || !response?.data?.data) {
        throw new Error(response?.message || 'Unexpected Error')
      }

      return response.data.data
    } catch (error) {
      console.error('Error fetching data', error)
      throw error
    }
  }
}

export default ApplicationService
